<script setup lang="ts">
import type { LocalizedString } from 'lc-repository/entities'

const { locale } = useI18n()
defineProps<{
  bed: {
    quantity: number
    name: LocalizedString
    bedSize?: string
  } | null
  highlights: Record<string, LocalizedString> | null
  name: LocalizedString
}>()
</script>

<template>
  <div class="flex w-full flex-col gap-1 sm:gap-2">
    <div
      class="flex flex-wrap items-center gap-x-3 gap-y-1.5 pt-4 sm:gap-x-4 sm:pt-0"
    >
      <h3 class="mb-0 text-xl sm:text-[28px]">
        {{ name[locale] }}
      </h3>
      <div v-if="highlights" class="flex items-center gap-2 sm:gap-4">
        <p
          v-for="(highlight, key) in highlights"
          :key="key"
          class="mb-0 w-fit rounded-full bg-secondary-100 px-2 py-1 text-center text-xs font-medium text-secondary-400 sm:text-md"
        >
          {{ highlight[locale] }}
        </p>
      </div>
    </div>
    <p v-if="bed" class="mb-0 w-fit text-xs sm:text-md">
      <span>{{ bed.quantity }} {{ bed.name[locale] }}</span>
      <span v-if="bed.bedSize"> ({{ bed.bedSize }})</span>
    </p>
  </div>
</template>
